<template>
  <div></div>
</template>

<script setup>
import { UsersService } from "@/services/api/users.api.service"
import {playNotySound} from "@/services/sound.service"
import { computed, getCurrentInstance, onMounted } from "vue"
import { useStore } from "vuex"

const store = useStore()
const noty = getCurrentInstance()?.appContext?.app?.noty

let messaging = null

const user = computed(() => store.state.auth.user)

// the token of this browser is registered for the user, once
const getFCMToken = (getToken) => {
  getToken(messaging, { vapidKey: 'BIeEdHVgaob9yC5BwUENSXwGVVlTQTSOvW9xp3TAd3xr2Vyop_6-XD6Rcy2WqwfKXmlVfSHc4Zxlr4lEWjePWH8' }).then((currentToken) => {
    if (currentToken) {
      console.log(`%cFCM: %c${currentToken}`, 'color: darkcyan;', 'color: grey;')
      const params = {
        token: currentToken,
        type: 'web',
        user_id: user.value ? user.value.id : null
      }
      const existingToken = user.value.fcm_tokens.find(x => x.token === currentToken)
      if(!existingToken) UsersService.fcmToken(params)
    } else {
      console.log('No registration token available. Request permission to generate one.')
    }
  }).catch(() => {
    console.log('The notification permission was not granted and blocked instead. (messaging/permission-blocked).')
  })
}

// messages received while the app is open
const receivingMessages = (onMessage) => {
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload)
    const notification = payload.notification
    const messageBody = [notification.title, notification.body].filter(x => x).join(' ')
    noty.info(messageBody)
    playNotySound()
  })
}

// firebase is loaded here, not on startup
onMounted(async () => {
  const [{ app }, { getMessaging, getToken, isSupported, onMessage }] = await Promise.all([
    import("@/extensions/firebase/firebase"),
    import("firebase/messaging")
  ])
  if(await isSupported()) {
    messaging = getMessaging(app)
    getFCMToken(getToken)
    receivingMessages(onMessage)
  }
})
</script>
